export const sortingArray = ['OP', 'IP', 'OTH']
